export var TrackerEventType;
(function (TrackerEventType) {
    TrackerEventType[TrackerEventType["Noop"] = 0] = "Noop";
    TrackerEventType[TrackerEventType["HTMLSnapshot"] = 101] = "HTMLSnapshot";
    TrackerEventType[TrackerEventType["HTMLMutations"] = 102] = "HTMLMutations";
    TrackerEventType[TrackerEventType["HTMLScroll"] = 103] = "HTMLScroll";
    TrackerEventType[TrackerEventType["HTMLFocus"] = 104] = "HTMLFocus";
    TrackerEventType[TrackerEventType["HTMLBlur"] = 105] = "HTMLBlur";
    TrackerEventType[TrackerEventType["HTMLValueChange"] = 106] = "HTMLValueChange";
    TrackerEventType[TrackerEventType["HTMLSelectionChange"] = 107] = "HTMLSelectionChange";
    TrackerEventType[TrackerEventType["HTMLResize"] = 110] = "HTMLResize";
    TrackerEventType[TrackerEventType["HTMLIncrementalSnapshot"] = 111] = "HTMLIncrementalSnapshot";
    TrackerEventType[TrackerEventType["HTMLNavigation"] = 115] = "HTMLNavigation";
    TrackerEventType[TrackerEventType["HTMLCanvas"] = 120] = "HTMLCanvas";
    TrackerEventType[TrackerEventType["HTMLImage"] = 122] = "HTMLImage";
    TrackerEventType[TrackerEventType["HTMLIFrame"] = 130] = "HTMLIFrame";
    TrackerEventType[TrackerEventType["MouseMove"] = 201] = "MouseMove";
    TrackerEventType[TrackerEventType["MouseDown"] = 202] = "MouseDown";
    TrackerEventType[TrackerEventType["MouseUp"] = 203] = "MouseUp";
    TrackerEventType[TrackerEventType["MouseClick"] = 204] = "MouseClick";
    TrackerEventType[TrackerEventType["TouchStart"] = 205] = "TouchStart";
    TrackerEventType[TrackerEventType["TouchMove"] = 206] = "TouchMove";
    TrackerEventType[TrackerEventType["TouchEnd"] = 207] = "TouchEnd";
    TrackerEventType[TrackerEventType["TouchCancel"] = 208] = "TouchCancel";
    TrackerEventType[TrackerEventType["KeyDown"] = 301] = "KeyDown";
    TrackerEventType[TrackerEventType["ConsoleAssert"] = 401] = "ConsoleAssert";
    TrackerEventType[TrackerEventType["ConsoleDebug"] = 402] = "ConsoleDebug";
    TrackerEventType[TrackerEventType["ConsoleDir"] = 403] = "ConsoleDir";
    TrackerEventType[TrackerEventType["ConsoleDirxml"] = 404] = "ConsoleDirxml";
    TrackerEventType[TrackerEventType["ConsoleError"] = 405] = "ConsoleError";
    TrackerEventType[TrackerEventType["ConsoleInfo"] = 406] = "ConsoleInfo";
    TrackerEventType[TrackerEventType["ConsoleLog"] = 407] = "ConsoleLog";
    TrackerEventType[TrackerEventType["ConsoleTable"] = 408] = "ConsoleTable";
    TrackerEventType[TrackerEventType["ConsoleTrace"] = 409] = "ConsoleTrace";
    TrackerEventType[TrackerEventType["ConsoleWarn"] = 410] = "ConsoleWarn";
    TrackerEventType[TrackerEventType["ERROR_SCRIPT"] = 501] = "ERROR_SCRIPT";
    TrackerEventType[TrackerEventType["ERROR_RUNTIME"] = 502] = "ERROR_RUNTIME";
    TrackerEventType[TrackerEventType["ERROR_NOTFOUND"] = 503] = "ERROR_NOTFOUND";
    TrackerEventType[TrackerEventType["ERROR_PROMISEREJECTION"] = 504] = "ERROR_PROMISEREJECTION";
    TrackerEventType[TrackerEventType["NETWORK_SEND"] = 601] = "NETWORK_SEND";
    TrackerEventType[TrackerEventType["NETWORK_DONE"] = 602] = "NETWORK_DONE";
    TrackerEventType[TrackerEventType["NETWORK_ABORT"] = 603] = "NETWORK_ABORT";
    TrackerEventType[TrackerEventType["NETWORK_ERROR"] = 604] = "NETWORK_ERROR";
    TrackerEventType[TrackerEventType["NETWORK_TIMEOUT"] = 605] = "NETWORK_TIMEOUT";
    TrackerEventType[TrackerEventType["INSIGHT_RAGE_CLICK"] = 701] = "INSIGHT_RAGE_CLICK";
    TrackerEventType[TrackerEventType["INSIGHT_DEAD_CLICK"] = 702] = "INSIGHT_DEAD_CLICK";
    TrackerEventType[TrackerEventType["INSIGHT_LONG_HOVER"] = 703] = "INSIGHT_LONG_HOVER";
    TrackerEventType[TrackerEventType["INSIGHT_EXCESSIVE_SCROLLING"] = 704] = "INSIGHT_EXCESSIVE_SCROLLING";
    TrackerEventType[TrackerEventType["PERFORMANCE_LONG_TASK"] = 801] = "PERFORMANCE_LONG_TASK";
    TrackerEventType[TrackerEventType["PERFORMANCE_RESOURCE"] = 802] = "PERFORMANCE_RESOURCE";
    TrackerEventType[TrackerEventType["PERFORMANCE_NAVIGATION"] = 803] = "PERFORMANCE_NAVIGATION";
})(TrackerEventType || (TrackerEventType = {}));
